module.exports = __webpack_public_path__ + "static/sonic-02a57bf6b9dcf833fe12d109cb68603e.gif";